export default __webpack_public_path__ + "static/media/jestC.a0e941de.webp";